"use client";

import Link from "next/link";
import { useState } from "react";

interface PhoneLinkProps {
  telNumber: string;
  children: React.ReactNode;
}
const PhoneLink = ({ telNumber, children }: PhoneLinkProps) => {
  const [tel, setTel] = useState(`tel:+1${telNumber}}`);

  const handleTelReset = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    window.location.href = tel;

    // reset link
    setTimeout(() => {
      setTel(`tel:+1${telNumber}`);
    }, 100);
  };

  return (
    <Link href={tel} onClick={handleTelReset}>
      {children}
    </Link>
  );
};

export default PhoneLink;
